import { OtpInput } from "@/components";
import { FormatTime, WEB_COLORS } from "@/lib/constants";
import { QueryBuilder } from "@mui/icons-material";
import { Stack, Tooltip, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

function VerifyOtpModalFields({
  formik,
  timeLeft,
  resetTimer,
  generateOtp,
  otpVerifying,
  handleOtpSubmit,
  verificationFailedReason,
}) {
  const t = useTranslations("Login");
  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Typography
          display={"block"}
          color={WEB_COLORS.textFadeColor}
          fontSize={{ xs: 14, sm: 16 }}
        >
          Please enter the OTP code sent to
        </Typography>
        {formik.values.phone ? (
          <Typography
            variant="span"
            sx={{
              display: "block",
              textAlign: "center",
              color: WEB_COLORS.primary,
              fontWeight: 500,
            }}
          >
            +91 {formik.values.phone}
          </Typography>
        ) : (
          <Typography fontWeight={700}>{t("regmobile")}</Typography>
        )}
      </Stack>
      <OtpInput
        length={4}
        onOtpSubmit={handleOtpSubmit}
        isLoading={otpVerifying}
        error={verificationFailedReason?.data?.message}
      />
      {verificationFailedReason?.data?.message && (
        <Typography
          sx={{ color: "#d32f2f", fontSize: 12, mt: 0 }}
          align="center"
        >
          {verificationFailedReason?.data?.message}
        </Typography>
      )}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={1}
      >
        <Typography
          variant="span"
          fontSize={{ xs: 14, sm: 16 }}
          color={WEB_COLORS.textFadeColor}
        >
          {timeLeft !== 0 ? t("resendotpin") : t("didntgetotp")}
        </Typography>
        {timeLeft !== 0 ? (
          <>
            <QueryBuilder fontSize="14" sx={{ color: WEB_COLORS.fadeColor2 }} />
            <Typography
              align="center"
              minWidth={40}
              maxWidth={40}
              color={WEB_COLORS.fadeColor2}
            >
              {FormatTime(timeLeft)}
            </Typography>
          </>
        ) : (
          <Tooltip title="Resend an OTP for the above mobile number">
            <a
              style={{
                ml: 1,
                fontSize: { xs: 14, sm: 16 },
                cursor: "pointer",
              }}
              onClick={() => {
                resetTimer();
                generateOtp({ phone: formik?.values?.phone, terms: true });
              }}
            >
              {t("resendotp")}
            </a>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  );
}

export default VerifyOtpModalFields;
